import Card from "@material-ui/core/Card";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { theme } from "..";
import { useAppState } from "../../../../common/appState";
import { appPublicImg, lingualNinjaUrl } from "../../../../common/consts";
import { sleepAsync } from "../../../../common/functions";
import { useScreenSize } from "../../../../common/hooks/useScreenSize";
import { ATargetBlank } from "../../../shared/Link/ATargetBlank";

export function RightBottomMessageArea() {
    const [rightBottomMessage] = useAppState("rightBottomMessage");
    const { screenWidth } = useScreenSize();

    const [shown, setShown] = useState(true);
    useEffect(() => {
        if (
            rightBottomMessage === "FlashcardsSharing" ||
            rightBottomMessage === "PoweredByLingualNinja"
        ) {
            sleepAsync(500).then(() => {
                setShown(true);
            });
            return;
        }
        setShown(false);
    }, [rightBottomMessage]);

    switch (rightBottomMessage) {
        case null: {
            return null;
        }
        case "FlashcardsSharing": {
            return (
                <Link
                    style={{
                        textDecoration: "none",
                        color: "inherit",
                        cursor: "pointer",
                        position: "absolute",
                        top: -30,
                        ...(screenWidth > 1000
                            ? { right: shown ? 46 : -300 }
                            : { left: shown ? 3 : -300 }),
                        fontSize: 15,
                        height: 26,
                        transition: "all 600ms",
                        overflow: "hidden",
                        whiteSpace: "nowrap",
                    }}
                    to={"/flashcard"}
                >
                    <Card
                        elevation={5}
                        style={{
                            padding: "1px 8px 1px 5px",
                            display: "flex",
                            alignItems: "center",
                            gap: 8,
                            color: theme.palette.primary.main,
                            fontWeight: 500,
                        }}
                    >
                        <img
                            src={`${appPublicImg}character.png`}
                            style={{ width: 16, height: 20 }}
                        />
                        Japanese Flashcards Sharing
                    </Card>
                </Link>
            );
        }
        case "PoweredByLingualNinja": {
            return (
                <ATargetBlank
                    style={{
                        textDecoration: "none",
                        color: "inherit",
                        cursor: "pointer",
                        position: "absolute",
                        top: -30,
                        ...(screenWidth > 1000
                            ? { right: shown ? 46 : -300 }
                            : { left: shown ? 3 : -300 }),
                        fontSize: 15,
                        height: 26,
                        maxWidth: shown ? 300 : 0,
                        transition: "all 600ms",
                        overflow: "hidden",
                        whiteSpace: "nowrap",
                    }}
                    href={lingualNinjaUrl}
                >
                    <Card
                        elevation={5}
                        style={{
                            padding: "1px 8px 1px 5px",
                            display: "flex",
                            alignItems: "center",
                            gap: 8,
                        }}
                    >
                        <img
                            src={`${lingualNinjaUrl}/favicon.ico`}
                            style={{ width: 20, height: 20 }}
                        />
                        Powered by{" "}
                        <span
                            style={{
                                color: theme.palette.primary.main,
                                fontWeight: 500,
                            }}
                        >
                            Lingual Ninja
                        </span>
                    </Card>
                </ATargetBlank>
            );
        }
        default: {
            const _exhaustiveCheck: never = rightBottomMessage;
            return null;
        }
    }
}
